<div class="bc-panel bc-panel-maxh">
  <div
    class="gc-email-widget-body {{ themeClass }}"
    *ngIf="!isTransferPanelOpen"
  >
    <app-genesys-email-viewer *ngIf="lastEmailMessage" [emailMessage]="lastEmailMessage"> </app-genesys-email-viewer>

    <app-genesys-email-footer
      *ngIf="!isProactiveEmail; else proactiveEmailTpl"
      [isFocused]="isFocused"
      [isExpanded]="isExpanded"
      [lastEmail]="lastEmailMessage"
      [isLastEmailFromCustomer]="isLastEmailFromCustomer"
      [agentEmailAddress]="agentEmailAddress"
      [conversationId]="conversationId"
      [draftEmail]="draftEmail"
      [emailError]="emailError"
      (openTransferPanel)="onTransferPanelOpen()"
    ></app-genesys-email-footer>
    <ng-template #proactiveEmailTpl>
      <app-genesys-proactive-email
        [customerEmailAddresses]="customerEmailAddresses"
        [agentEmailAddress]="agentEmailAddress"
        [isFocused]="isFocused"
        [isExpanded]="isExpanded"
        [conversationId]="conversationId"
        [draftEmail]="draftEmail"
      ></app-genesys-proactive-email>
    </ng-template>
  </div>

  <app-genesys-transfer-panel
    *ngIf="isTransferPanelOpen"
    class="gc-chat-box-transfer-panel"
    [conversationId]="conversationId"
    [agentParticipantId]="agentParticipantId"
    [communicationType]="communicationTypes.Email"
    (cancel)="onTransferPanelCancel()"
  >
  </app-genesys-transfer-panel>
</div>

<div class="inactive-email-panel-footer" *ngIf="!isFocused">
  <app-inactive-widget-footer></app-inactive-widget-footer>
</div>
